const htmlUnescapeMap = {
  '&amp;': '&',
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&#39;': "'",
};

const htmlUnescape = (str) => {
  if (typeof str !== 'string') return str;
  return str.replace(/&amp;|&lt;|&gt;|&quot;|&#39;/g, (match) => htmlUnescapeMap[match]);
};

export default htmlUnescape;
